import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { FaqPage } from "./faq";
import { DICTS, LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { hreflangLinks } from "../lib/seo";

export const Route = createFileRoute("/$locale/faq")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/faq" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  head: (ctx) => {
    const lang = ctx.params.locale as Lang;
    const d = DICTS[lang];
    return {
      meta: [
        { title: `${d.faq_title} | sunbedly` },
        { name: "description", content: d.faq_sub },
      ],
      links: hreflangLinks("/faq", ctx.params.locale),
    };
  },
  component: FaqPage,
});
